<template>
    <div class="">
        <div class="recommended-grids">
            <div class="recommended-info">
                <h3>{{ liveTitle }}</h3>
            </div>
            <div class="col-lg-3 col-md-4 col-sm-6 resent-grid recommended-grid"  v-for="(data, index) in liveArray" :key="index">
                <div class="resent-grid-img recommended-grid-img">
                    <router-link :to="{name: 'LiveWatch', params:{ lid:data.id }}">
                        <div class="zoomImage" :style="'background-image:url('+data.picture+')'"></div>
                    </router-link>
                </div>
                <div class="resent-grid-info recommended-grid-info video-info-grid">
                    <h5>
                        <router-link :to="{name: 'LiveWatch', params:{ lid:data.id }}" class="title">
                            {{ data.title }}
                        </router-link>
                    </h5>
                    <ul>
<!--                        <li><p class="author author-info"><a href="javascript:void(0);" class="author" style="cursor:text;">CmsDemo</a></p></li>-->
                    </ul>
                </div>
            </div>
        </div>
        <div class="clearfix"></div>
    </div>
</template>

<script>
export default {
  props: ['liveTitle', 'liveArray']
}
</script>
